import { loop, Cmd } from 'redux-loop';

const TARGET_BASE = 'active_wait__';
const DEFAULT_TIMEOUT = 2000; // TODO: Exponential backoff
const initialState = []; // No ongoing requests

const waitDone = (endpoint) => ({
  type: 'ACTIVE_WAIT_COMPLETE',
  endpoint,
});

const waitFailed = (endpoint) => ({
  type: 'ACTIVE_WAIT_FAILED',
  endpoint,
});

const launchRequest = (endpoint) => ({
  type: 'API_CALL_REQUEST',
  target: `${TARGET_BASE}${endpoint}`,
  endpoint,
  method: 'GET',
  body: null,
});

const delayValue = async (value, delay) => {
  await new Promise(resolve => setTimeout(resolve, delay));
  return value;
};


const reducer = (state = initialState, action) => {
  let endpoint = '';
  switch(action.type) {
    case 'ACTIVE_WAIT_REQUEST':
      endpoint = action.endpoint;
      if(state.find(el => el === endpoint)) {
        return state; // Already running for this endpoint...
      }

      return loop(
        [ ...state, endpoint ],
        Cmd.action(launchRequest(endpoint)));
    case 'API_CALL_COMPLETE':
      if(!action.response || !(action.response.target || '').startsWith(TARGET_BASE)) return state;
      endpoint = action.response.target.replace(TARGET_BASE, '');

      switch(action.response.result) {
        case 'created': // Meaning: we are still waiting
        case 'active':
        case 'retry':
          return loop(state, Cmd.run(delayValue,
                                     {
                                       successActionCreator: launchRequest,
                                       args: [ endpoint, DEFAULT_TIMEOUT ],
                                     }))
        case 'completed': // Meaning we are done
          return loop(
            state.filter(el => el !== endpoint),
            Cmd.action(waitDone(endpoint))
          );
        case 'failed':
        case 'cancelled':
        case 'expired':
          return loop(
            state.filter(el => el !== endpoint),
            Cmd.action(waitFailed(endpoint))
          );
        default:
          return state;
      }
    case 'API_CALL_FAILED':
      if(!action.response || !(action.response.target || '').startsWith(TARGET_BASE)) return state;
      endpoint = action.response.target.replace(TARGET_BASE, '');

      // TODO: MAybe consider API errors as not errors for a while, but rather bad connection, etc.
      return loop(
        state.filter(el => el !== endpoint),
        Cmd.action(waitFailed(endpoint))
      );
    default:
      return state;
  }
}

export {
  reducer as active_wait,
};
